/**
 * Format a percent value to 2 decimals
 * @param value - non-percent number
 * @returns
 */
export function formatPercentValue(value: number): string {
    return value.toLocaleString("en-US", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
    });
}
